import { Injectable } from '@angular/core';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class ChartOfAccountService {
  url: string = 'chart_of_accounts';

  constructor(private httpClient: HttpClientService) {}

  forFormOptions(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { for_form_options: true });
  }
}
